import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import { SET_SUCCESS_PROMPT_SRGLINES_PAGE } from "externalFeatures/store/actionTypes/smrt/srgLinesActionType";

const SrgLinesSuccessPrompt = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    isSuccessPromptSrgLines: isSuccess,
    successMessageSrgLines: successMessage,
  } = useSelector((state) => state.srgLines);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_SUCCESS_PROMPT_SRGLINES_PAGE, payload: false });
  };

  return (
    isSuccess && (
      <Alert
        sx={{ my: 2 }}
        severity="success"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{t("successPromptTitle")}</AlertTitle>
        {successMessage}
      </Alert>
    )
  );
};

export default SrgLinesSuccessPrompt;
